interface MessageSvgProps {
  color: string;
  style: React.CSSProperties;
}

const MessageSvg = ({ color, style }: MessageSvgProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 40.883L22.6627 33.75H37.5C39.5711 33.75 41.25 32.0711 41.25 30V7.5C41.25 5.42893 39.5711 3.75 37.5 3.75H7.5C5.42893 3.75 3.75 5.42893 3.75 7.5V30C3.75 32.0711 5.42893 33.75 7.5 33.75H11.25V40.883ZM21.5873 30L15 34.117V30H7.5V7.5H37.5V30H21.5873ZM13.125 24.375V20.625H26.25V24.375H13.125ZM13.125 13.125V16.875H30V13.125H13.125Z"
      fill={color}
    />
  </svg>
);

export default MessageSvg;
